<template>
     <div class="tab-content" id="nav-tabContent" v-if="Object.keys(parent).length && hasPermissions(['Days-Off-Schedule Read', 'Days-Off-Schedule Read-Assigned-Schedules'])">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <div class="templates__table" v-if="schedules.length">
                    <div class="table-responsive schedule-table" :class="(hasPermissions(['Days-Off-Schedule Read-Assigned-Schedules']) && !hasPermissions(['Days-Off-Schedule Read'])) || used_in == 'home' ? 'home-table-schedule' : ''">
                        <table class="table"> 
                            <thead style="background-color: #f1f1f1;">
                                <tr>
                                    <th scope="col" v-if="used_in === 'live_schedules' || used_in === 'templates' && hasPermissions(['Days-Off-Schedule Write'])">
                                        <span class="custom-control custom-checkbox">
                                            <input :id="`theadcheck`" v-model="massive_all" type="checkbox" class="custom-control-input"/>
                                            <label :for="`theadcheck`" class="custom-control-label ml-2"/>
                                        </span>
                                    </th>
                                    <th scope="col">
                                        <strong v-html="`${view_by_associate ? 'Associates' : 'Daily Assignments'}`"/>
                                    </th>
                                    <th  scope="col">
                                        <strong v-html="`Days Scheduled`"/>
                                    </th>
                                    <th scope="col" v-for="(item, i) in schedule_header" :key="i" style="padding: 5px;">
                                    {{ item.name }}
                                    <br>
                                    <a style="color: #039be5"><b>{{used_in != 'templates' ?  item.date : (i + 1)}}</b></a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="view_by_associate">
                                    <tr v-for="(item, i) in schedules"  :key="i">
                                        <slot v-if="item.show">
                                            <th scope="row" v-if="used_in === 'live_schedules' || used_in === 'templates' && hasPermissions(['Days-Off-Schedule Write'])">
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`item${i}`" v-model="item.checked" type="checkbox" class="custom-control-input"/>
                                                    <label :for="`item${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </th>

                                            <th scope="row" v-html="item.associate" @click="setNewAssociate(i)" :style="hasPermissions(['Days-Off-Schedule Write']) ? 'cursor: pointer' : ''" style="min-width: 12rem; max-width: 12rem;"/>
                                            <th v-html="item.total_assignments"/>
                                            <td v-for="(prop, j) in item.rotation_day_assignments" :key="j" 
                                                class="live_schedules__item"
                                                :class="{
                                                            'full-color-time-off': prop.assignments && prop.assignments.length && prop.assignments[0].is_time_off, 
                                                            'full-color': used_in != 'templates' && prop.assignments && prop.assignments.length && !prop.assignments[0].is_time_off,
                                                            'full-color-template' : used_in == 'templates' && prop.assignments && prop.assignments.length && !prop.assignments[0].is_time_off,
                                                            'over-color': !prop.assignments || !prop.assignments.length,
                                                            'live_schedules__item--border-yellow': prop.assignments && prop.assignments.length && prop.repeated_assignments && prop.repeated_assignments.length,
                                                            'live_schedules__item--border-red': prop.assignments && prop.assignments.length && prop.repeated_assignments_associate && prop.repeated_assignments_associate.length 
                                                                                                || prop.assignments && prop.assignments.length && prop.repeated_time_offs && prop.repeated_time_offs.length,
                                                            'live_schedules__item--border-orange': prop.repeated_assignments_rotation,
                                                        }"
                                                
                                                        style="min-width: 10rem; max-width: 10rem;">
                                                <!-- <div  style-="box-sizing: content-box;"> -->
                                                    <span  v-for="(assignment, k) in prop.assignments" :key="k" style="color: #fff">
                                                        <a v-if="!assignment.is_time_off"
                                                        href="JavaScript:void(0);" v-html="assignment.number"
                                                        data-toggle="tooltip"  :title="assignment.description" 
                                                        style="color:white !important;"
                                                        @click="used_in === 'home' ? redirectToAssignment(prop.order, assignment.rotation_day_assignment_id) : setNewAssignment(i, j)"
                                                        />
                                                        <a v-else
                                                        href="JavaScript:void(0);" v-html="assignment.description"
                                                        style="color:white;"
                                                        @click="used_in === 'home' ? redirectToAssignment(prop.order, assignment.rotation_day_assignment_id) : setNewAssignment(i, j)"
                                                        />{{(prop.assignments.length > (k +1)) ? ', ': ''}}
                                                    </span>
                                                    <span class="live_schedules__item-warning_icon" data-toggle="tooltip"  v-if="tooltipText(prop.assignments, prop.repeated_assignments, prop.repeated_assignments_associate, prop.repeated_time_offs, prop.repeated_assignments_rotation)" 
                                                        :title="tooltipText(prop.assignments, prop.repeated_assignments, prop.repeated_assignments_associate, prop.repeated_time_offs, prop.repeated_assignments_rotation)">
                                                        <i class="fa fa-warning" >
                                                        </i>
                                                    </span>
                                                    <span v-if="!prop.assignments || !prop.assignments.length">
                                                        <a  style="color:white !important;" @click="setNewAssignment(i, j)">Off</a>
                                                    </span>
                                                <!-- </div> -->
                                            </td>
                                        </slot>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr v-for="(item, i) in schedules"  :key="i">
                                        <slot v-if="item.show">
                                            <th scope="row" v-if="used_in === 'live_schedules' || used_in === 'templates' && hasPermissions(['Days-Off-Schedule Write'])">
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="`item${i}`" v-model="item.checked" type="checkbox" class="custom-control-input" :disabled="massive_all"/>
                                                    <label :for="`item${i}`" class="custom-control-label ml-2"/>
                                                </span>
                                            </th>

                                            <th scope="row" v-html="item.daily_assignment" @click="setNewAssociate(i)" :style="hasPermissions(['Days-Off-Schedule Write']) ? 'cursor: pointer' : ''" style="min-width: 12rem; max-width: 12rem;"/>
                                            <th v-html="item.total_associates"/>
                                            <td v-for="(prop, j) in item.rotation_day_assignments" :key="j" 
                                                class="live_schedules__item"
                                                :class="{
                                                        'full-color': used_in != 'templates' && prop.associates && prop.associates.length,
                                                        'full-color-template' : used_in == 'templates' && prop.associates  && prop.associates.length,
                                                        'over-color': !prop.associates || !prop.associates.length,
                                                        }"
                                                style="min-width: 10rem; max-width: 10rem;">
                                                <span  v-for="(associate, k) in prop.associates" :key="k">
                                                    <a
                                                    href="JavaScript:void(0);" v-html="associate.name"
                                                    data-toggle="tooltip"  :title="associate.name" 
                                                    style="color:white !important;"
                                                    @click="used_in === 'home' ? redirectToAssignment(prop.order, associate.rotation_day_assignment_id) : setNewAssignment(i, j)"
                                                    />
                                                    <br />
                                                </span>
                                                <span v-if=" !prop.associates || !prop.associates.length">
                                                    <a  style="color:white !important;" @click="setNewAssignment(i, j)">Off</a>
                                                </span>
                                            </td>
                                        </slot>
                                    </tr>
                                </template>
                            </tbody>
                            <tfoot v-if="used_in != 'home' && hasPermissions(['Days-Off-Schedule Read'])">
                                <tr v-if="view_by_associate">
                                    <th></th>
                                    <th>TOTAL ASSIGNED</th>
                                    <th></th>
                                    <td v-for="(prop, j) in parent.rotation_days" :key="j">
                                        {{used_in === 'live_schedules' ? prop.total_associates_schedule : prop.total_associates_template}}
                                    </td>
                                </tr>
                                 <tr v-else>
                                    <th></th>
                                    <th>TOTAL ASSIGNED</th>
                                    <th></th>
                                    <td v-for="(prop, j) in parent.rotation_days" :key="j">
                                        {{used_in === 'live_schedules' ? prop.total_assignments_schedule : prop.total_assignments_template}}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

        </div>
</template>
<script>

import moment from 'moment'

export default{
    name: 'ScheduleTable',
    props: [
        'parent',
        'rest_api',
        'schedules',
        'new_start_date',
        'used_in',
        'viewing_schedule',
        'prior_start_date',
        'editable',
        'view_by_associate',
        'form_data'
    ],
    data()
    {
        return {
            massive_all: false,
            schedule_header: [],
            order_of_today: null,
            moment
        }
    },

    watch:
    {
        massive_all(val)
        {
            this.schedules.map(item => item.checked = val)
        },

        schedules()
        {
            this.scheduleFormatIncrease();
        },

        templates()
        {
            this.scheduleFormatIncrease();
        }
    },

    methods: 
    {
        scheduleFormatIncrease()
        {
            this.form_data ? this.form_data.rotation_days = [] : ''

            this.schedule_header = []

            let prior_start_date_formatted = (this.prior_start_date) ? this.prior_start_date.split('/').join('.') : ''
            
 
            let prior_date =  moment(prior_start_date_formatted, 'DD-MM-YYYY');
            let today = moment();

            if(this.parent && this.parent.rotation_days && this.parent.rotation_days.length)
            {
                for(let i = 0; i < this.parent.rotation_days.length; i++)
                {

                    if(prior_date.format("MM/DD/YYYY") === today.format("MM/DD/YYYY"))
                    {
                        this.order_of_today = i
                    }	
                    

                    this.schedule_header.push({
                        name: prior_date.format('dddd'),
                        date: prior_date.format("MM/DD"),
                        date_for_backend: prior_date.format("YYYY-MM-DD")

                    })

                    if(this.form_data)
                    {
                        this.form_data.rotation_days.push(
                        {
                            schedule_day: (prior_date.format('d') == 0) ? 7 :prior_date.format('d'),
                            day_date: `${prior_date.format('dddd')} - ${prior_date.format("MM/DD")}`,
                            day_number: `${prior_date.format('dddd')} - ${i + 1}`,
                            daily_assignment_id: '',
                            order: i,
                            id: this.parent.rotation_days[i].id,
                        })
                    }

                    prior_date.add(1, 'days')
                }
            }

        },

        setNewAssignment(index, index_item)
        {
            if(this.editable == true)
            {
                if(this.view_by_associate)
                {
                    this.$emit('setNewAssignment', {index, index_item, date_for_backend: this.schedule_header[index_item].date_for_backend})
                }
                else
                {
                    this.$emit('setAssociates', {index, index_item})
                }
            }
        },

        setNewAssociate(index)
        {
            if(this.editable == true)
            {
                if(this.view_by_associate)
                {
                    this.$emit('setNewAssociate', index)
                }
                else
                {
                    this.$emit('setMainAssignment', index)
                }
            }

        },

        tooltipText(assignments, repeated_assignments, repeated_assignments_associate, repeated_time_offs, repeated_assignments_rotation)
        {
            if(assignments && assignments.length)
            {
                if(repeated_assignments.length)
                {
                    return `This associate has been assigned on this day with the same assignment as another associate(s)`
                }
                else if(repeated_assignments_associate && repeated_assignments_associate.length || repeated_time_offs && repeated_time_offs.length)
                {
                    return `This associate has been assigned to this date on ${repeated_assignments_associate.length + repeated_time_offs.length} ${this.used_in === 'templates' ? 'master(s) days off' : this.viewing_schedule == 3 ? 'future schedule(s)' : 'live schedule(s)'}`
                }
                else if(repeated_assignments_rotation)
                {
                    return `This associate has been assigned on this day to different assignments on this rotation`
                }

               return false
            }
            return false
        },

        redirectToAssignment(order, encrypt_daily_assignment)
        {
            if(this.order_of_today === order)
            {
                this.$router.push({path: `schedule-complete/${encrypt_daily_assignment}`})
            }
        }
    },
    computed: {
        
    }
    
}
</script>
